(() => {
  'use strict';

  const STORAGE_KEY = 'baristayou_wishlist_v1';
  const BY_WL_LANG=(document.documentElement.lang||'de').toLowerCase().split('-')[0];
  const BY_WL_TEXT={de:{add:'Zur Merkliste',on:'Auf Merkliste'},en:{add:'Add to wishlist',on:'On wishlist'},fr:{add:'Ajouter aux favoris',on:'Dans les favoris'},es:{add:'Añadir a favoritos',on:'En favoritos'},nl:{add:'Aan verlanglijst toevoegen',on:'Op verlanglijst'}}[BY_WL_LANG]||{add:'Zur Merkliste',on:'Auf Merkliste'};


  const BY_QUOTE_TEXT={"de":{"button":"Angebot anfragen","label":"Angebot für","tail":"anfragen","hello":"Hallo BaristaYOU,","intro":"ich interessiere mich für folgendes Produkt und möchte gerne ein Angebot erhalten:","thanks":"Vielen Dank!","product":"dieses Produkt"},"en":{"button":"Request a quote","label":"Request a quote for","tail":"","hello":"Hello BaristaYOU,","intro":"I am interested in the following product and would like to receive a quote:","thanks":"Thank you!","product":"this product"},"fr":{"button":"Demander un devis","label":"Demander un devis pour","tail":"","hello":"Bonjour BaristaYOU,","intro":"Ce produit m’intéresse et je souhaiterais recevoir un devis :","thanks":"Merci !","product":"ce produit"},"es":{"button":"Solicitar presupuesto","label":"Solicitar presupuesto para","tail":"","hello":"Hola BaristaYOU,","intro":"Me interesa el siguiente producto y quisiera recibir un presupuesto:","thanks":"¡Gracias!","product":"este producto"},"nl":{"button":"Offerte aanvragen","label":"Offerte aanvragen voor","tail":"","hello":"Hallo BaristaYOU,","intro":"Ik ben geïnteresseerd in het volgende product en ontvang graag een offerte:","thanks":"Bedankt!","product":"dit product"}}[BY_WL_LANG]||{"button":"Request a quote","label":"Request a quote for","tail":"","hello":"Hello BaristaYOU,","intro":"I am interested in the following product and would like to receive a quote:","thanks":"Thank you!","product":"this product"};
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"></path></svg>';
  let items = load();
  let observerTimer;

  function load() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      const seen = new Set();
      return parsed.filter((item) => {
        if (!item || !item.handle || seen.has(item.handle)) return false;
        seen.add(item.handle);
        return true;
      });
    } catch (_) { return []; }
  }

  function persist(message) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (_) {}
    updateUI();
    if (message) toast(message);
  }

  function clean(value) { return String(value || '').replace(/\s+/g, ' ').trim(); }
  function absolute(url) { try { return new URL(url, location.origin).toString(); } catch (_) { return url || ''; } }
  function getHandle(url) { try { const match = new URL(url, location.origin).pathname.match(/\/products\/([^/]+)/); return match ? decodeURIComponent(match[1]) : ''; } catch (_) { return ''; } }
  function imageSrc(img) { return img ? (img.currentSrc || img.src || img.getAttribute('src') || '') : ''; }
  function isSaved(handle) { return items.some((item) => item.handle === handle); }

  function add(item) {
    if (!item || !item.handle || isSaved(item.handle)) return;
    items.unshift({handle:item.handle,url:absolute(item.url),title:clean(item.title),image:item.image||'',price:clean(item.price),vendor:clean(item.vendor)});
    persist('Zur Merkliste hinzugefügt');
  }

  function removeByHandle(handle) {
    if (!handle) return;
    const before = items.length;
    items = items.filter((item) => item.handle !== handle);
    if (items.length !== before) persist('Aus Merkliste entfernt');
    else updateUI();
  }

  function toggle(item) {
    if (!item || !item.handle) return;
    if (isSaved(item.handle)) removeByHandle(item.handle);
    else add(item);
  }

  function heartControl(item, buttonElement) {
    const control = document.createElement(buttonElement ? 'button' : 'span');
    control.className = 'by-wishlist-heart';
    control.dataset.byWishlistHandle = item.handle;
    control.innerHTML = HEART;
    if (buttonElement) control.type = 'button'; else { control.setAttribute('role','button'); control.tabIndex = 0; }
    const activate = (event) => { event.preventDefault(); event.stopPropagation(); toggle(item); };
    control.addEventListener('click', activate);
    if (!buttonElement) control.addEventListener('keydown', (event) => { if (event.key === 'Enter' || event.key === ' ') activate(event); });
    return control;
  }

  function enhanceGridCard(card) {
    if (!card || card.dataset.byWishlistReady === 'true') return;
    const imageWrap = card.querySelector('[data-product-image]'); if (!imageWrap) return;
    const url = card.dataset.url || card.querySelector('[data-product-link]')?.getAttribute('href') || card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    const image = imageWrap.querySelector('img');
    const item = {handle:getHandle(url),url,title:card.querySelector('.product-item__title')?.textContent||image?.alt||'',image:imageSrc(image),price:card.querySelector('.product-item__price')?.textContent||'',vendor:card.querySelector('.product-item__vendor, [data-product-vendor]')?.textContent||''};
    if (!item.handle) return;
    imageWrap.appendChild(heartControl(item,true)); card.dataset.byWishlistReady = 'true';
  }

  function enhanceHomeCard(card) {
    if (!card || card.dataset.byWishlistReady === 'true') return;
    const imageWrap = card.querySelector('.by-product__image'); if (!imageWrap) return;
    const url = card.getAttribute('href') || ''; const image = imageWrap.querySelector('img');
    const item = {handle:getHandle(url),url,title:card.querySelector('h3')?.textContent||image?.alt||'',image:imageSrc(image),price:card.querySelector('.by-product__price')?.textContent||'',vendor:card.querySelector('small')?.textContent||''};
    if (!item.handle) return;
    imageWrap.appendChild(heartControl(item,false)); card.dataset.byWishlistReady = 'true';
  }

  function getProductPageItem() {
    const data = document.getElementById('by-wishlist-product-data'); if (!data) return null;
    try { const item = JSON.parse(data.textContent); item.handle = item.handle || getHandle(item.url); return item.handle ? item : null; } catch (_) { return null; }
  }

  function enhanceProductPage() {
    if (document.querySelector('[data-by-wishlist-pdp]')) return;
    const item = getProductPageItem(); if (!item) return;
    const host = document.querySelector('.product__block--buttons .product__submit') || document.querySelector('.product__block--buttons') || document.querySelector('product-form'); if (!host) return;
    const button = document.createElement('button'); button.type='button'; button.className='by-wishlist-pdp'; button.dataset.byWishlistPdp=''; button.dataset.byWishlistHandle=item.handle;
    button.innerHTML = HEART + '<span data-by-wishlist-pdp-label>'+BY_WL_TEXT.add+'</span>';
    button.addEventListener('click',(event)=>{event.preventDefault();event.stopPropagation();toggle(item);}); host.appendChild(button);
  }

  function createHeaderButton(mobile) {
    const button = document.createElement('button'); button.type='button';
    button.className='by-wishlist-header ' + (mobile ? 'by-wishlist-header--mobile header__mobile__button' : 'by-wishlist-header--desktop header__desktop__button');
    button.dataset.byWishlistOpen=''; button.setAttribute('aria-label','Merkliste öffnen');
    button.innerHTML = HEART + '<span class="by-wishlist-count" data-by-wishlist-count hidden>0</span>';
    button.addEventListener('click',openDrawer); return button;
  }

  function enhanceHeader() {
    [['.header__desktop__buttons',false],['.header__mobile__right',true]].forEach(([selector,mobile])=>{
      document.querySelectorAll(selector).forEach((container)=>{
        if (container.querySelector('[data-by-wishlist-open]')) return;
        const button=createHeaderButton(mobile);
        const cart=container.querySelector('[data-drawer-toggle="drawer-cart"], [data-cart-toggle], a[href="/cart"]') || container.lastElementChild;
        if (cart && cart.parentNode===container) container.insertBefore(button,cart); else container.appendChild(button);
      });
    });
  }

  function buildDrawer() {
    if (document.querySelector('[data-by-wishlist-drawer]')) return;
    const overlay=document.createElement('div'); overlay.className='by-wishlist-overlay'; overlay.dataset.byWishlistOverlay=''; overlay.addEventListener('click',closeDrawer);
    const drawer=document.createElement('aside'); drawer.className='by-wishlist-drawer'; drawer.dataset.byWishlistDrawer=''; drawer.setAttribute('aria-hidden','true'); drawer.setAttribute('aria-label','Merkliste');
    drawer.innerHTML='<div class="by-wishlist-drawer__head"><div><span class="by-wishlist-drawer__eyebrow">BaristaYOU</span><h2>Deine Merkliste</h2></div><button type="button" class="by-wishlist-close" aria-label="Merkliste schließen" data-by-wishlist-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"></path></svg></button></div><div class="by-wishlist-drawer__body" data-by-wishlist-list></div><div class="by-wishlist-drawer__foot"><p>Deine Merkliste wird auf diesem Gerät gespeichert.</p></div>';
    drawer.querySelector('[data-by-wishlist-close]').addEventListener('click',closeDrawer); document.body.append(overlay,drawer);
  }

  function renderDrawer() {
    const list=document.querySelector('[data-by-wishlist-list]'); if (!list) return; list.replaceChildren();
    if (!items.length) { const empty=document.createElement('div'); empty.className='by-wishlist-empty'; empty.innerHTML=HEART+'<h3>Noch nichts gemerkt.</h3><p>Tippe bei deinen Favoriten auf das Herz – sie erscheinen dann hier.</p>'; list.appendChild(empty); return; }
    items.forEach((item)=>{
      const row=document.createElement('article'); row.className='by-wishlist-item';
      const imageLink=document.createElement('a'); imageLink.className='by-wishlist-item__image'; imageLink.href=item.url||'/products/'+encodeURIComponent(item.handle);
      if (item.image) { const img=document.createElement('img'); img.src=item.image; img.alt=item.title||'Produkt'; img.loading='lazy'; imageLink.appendChild(img); }
      const content=document.createElement('div'); content.className='by-wishlist-item__content';
      if (item.vendor) { const vendor=document.createElement('small'); vendor.textContent=item.vendor; content.appendChild(vendor); }
      const title=document.createElement('a'); title.className='by-wishlist-item__title'; title.href=imageLink.href; title.textContent=item.title||'Produkt'; content.appendChild(title);
      if (item.price) { const price=document.createElement('div'); price.className='by-wishlist-item__price'; price.textContent=item.price; content.appendChild(price); }
      const actions=document.createElement('div'); actions.className='by-wishlist-item__actions';
      const view=document.createElement('a'); view.className='by-wishlist-item__view'; view.href=imageLink.href; view.textContent='Produkt ansehen';
      const remove=document.createElement('button'); remove.type='button'; remove.className='by-wishlist-item__remove'; remove.setAttribute('aria-label',(item.title||'Produkt')+' aus Merkliste entfernen'); remove.textContent='Entfernen';
      remove.addEventListener('click',(event)=>{event.preventDefault();event.stopPropagation();removeByHandle(item.handle);});
      actions.append(view,remove); content.appendChild(actions); row.append(imageLink,content); list.appendChild(row);
    });
  }

  function openDrawer(event) { if (event) event.preventDefault(); buildDrawer(); renderDrawer(); const drawer=document.querySelector('[data-by-wishlist-drawer]'); const overlay=document.querySelector('[data-by-wishlist-overlay]'); if(!drawer||!overlay)return; drawer.classList.add('is-open'); overlay.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.classList.add('by-wishlist-open'); requestAnimationFrame(()=>drawer.querySelector('[data-by-wishlist-close]')?.focus()); }
  function closeDrawer(){document.querySelector('[data-by-wishlist-drawer]')?.classList.remove('is-open');document.querySelector('[data-by-wishlist-overlay]')?.classList.remove('is-open');document.querySelector('[data-by-wishlist-drawer]')?.setAttribute('aria-hidden','true');document.body.classList.remove('by-wishlist-open');}
  function toast(message){let node=document.querySelector('[data-by-wishlist-toast]');if(!node){node=document.createElement('div');node.className='by-wishlist-toast';node.dataset.byWishlistToast='';document.body.appendChild(node);}node.textContent=message;node.classList.add('is-visible');clearTimeout(node._timer);node._timer=setTimeout(()=>node.classList.remove('is-visible'),1800);}

  function updateUI(){
    document.querySelectorAll('[data-by-wishlist-count]').forEach((badge)=>{badge.textContent=items.length;badge.hidden=items.length===0;});
    document.querySelectorAll('[data-by-wishlist-handle]').forEach((control)=>{const active=isSaved(control.dataset.byWishlistHandle);control.classList.toggle('is-active',active);control.setAttribute('aria-pressed',active?'true':'false');if(control.classList.contains('by-wishlist-heart'))control.setAttribute('aria-label',active?'Aus Merkliste entfernen':'Zur Merkliste hinzufügen');});
    const pdp=document.querySelector('[data-by-wishlist-pdp]');if(pdp){const label=pdp.querySelector('[data-by-wishlist-pdp-label]');if(label)label.textContent=isSaved(pdp.dataset.byWishlistHandle)?BY_WL_TEXT.on:BY_WL_TEXT.add;}
    if(document.querySelector('[data-by-wishlist-drawer].is-open'))renderDrawer();
  }

  function enhanceAll(){document.querySelectorAll('[data-grid-item]').forEach(enhanceGridCard);document.querySelectorAll('a.by-product').forEach(enhanceHomeCard);enhanceHeader();enhanceProductPage();updateUI();}
  function init(){buildDrawer();enhanceAll();const observer=new MutationObserver(()=>{clearTimeout(observerTimer);observerTimer=setTimeout(enhanceAll,80);});observer.observe(document.body,{childList:true,subtree:true});document.addEventListener('shopify:section:load',enhanceAll);document.addEventListener('shopify:section:reorder',enhanceAll);window.addEventListener('storage',(event)=>{if(event.key===STORAGE_KEY){items=load();updateUI();}});document.addEventListener('keydown',(event)=>{if(event.key==='Escape')closeDrawer();});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

(() => {
  'use strict';

  const BY_QUOTE_TEXT={"de":{"button":"Angebot anfragen","label":"Angebot für","tail":"anfragen","hello":"Hallo BaristaYOU,","intro":"ich interessiere mich für folgendes Produkt und möchte gerne ein Angebot erhalten:","thanks":"Vielen Dank!","product":"dieses Produkt"},"en":{"button":"Request a quote","label":"Request a quote for","tail":"","hello":"Hello BaristaYOU,","intro":"I am interested in the following product and would like to receive a quote:","thanks":"Thank you!","product":"this product"},"fr":{"button":"Demander un devis","label":"Demander un devis pour","tail":"","hello":"Bonjour BaristaYOU,","intro":"Ce produit m’intéresse et je souhaiterais recevoir un devis :","thanks":"Merci !","product":"ce produit"},"es":{"button":"Solicitar presupuesto","label":"Solicitar presupuesto para","tail":"","hello":"Hola BaristaYOU,","intro":"Me interesa el siguiente producto y quisiera recibir un presupuesto:","thanks":"¡Gracias!","product":"este producto"},"nl":{"button":"Offerte aanvragen","label":"Offerte aanvragen voor","tail":"","hello":"Hallo BaristaYOU,","intro":"Ik ben geïnteresseerd in het volgende product en ontvang graag een offerte:","thanks":"Bedankt!","product":"dit product"}}[(document.documentElement.lang||"de").toLowerCase().split("-")[0]]||{"button":"Request a quote","label":"Request a quote for","tail":"","hello":"Hello BaristaYOU,","intro":"I am interested in the following product and would like to receive a quote:","thanks":"Thank you!","product":"this product"};
  const QUOTE_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 5.5h16v13H4z"></path><path d="m4 7 8 6 8-6"></path></svg>';

  function ensureStyles() {
    if (document.getElementById('by-pdp-actions-styles')) return;
    const style = document.createElement('style');
    style.id = 'by-pdp-actions-styles';
    style.textContent = `
      html.by-pdp-premium body .product__block--buttons .product__submit--spb .product__submit__item + .product__submit__item {
        display: block !important;
        width: 100% !important;
        flex: 0 0 100% !important;
        margin-top: 10px !important;
      }
      html.by-pdp-premium body .product__block--buttons .shopify-payment-button {
        display: block !important;
        width: 100% !important;
      }
      html.by-pdp-premium body .product__block--buttons .shopify-payment-button__button {
        width: 100% !important;
        min-height: 52px;
        border-radius: 8px !important;
      }
      .by-pdp-secondary-actions {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        gap: 10px;
        width: 100%;
        margin-top: 10px;
      }
      .by-pdp-secondary-actions .by-wishlist-pdp,
      .by-pdp-quote {
        width: 100%;
        min-height: 52px;
        margin: 0;
        padding: 13px 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        box-sizing: border-box;
        border: 1px solid rgba(17,17,17,.20);
        border-radius: 8px;
        background: transparent;
        color: #171717;
        font: inherit;
        font-weight: 600;
        line-height: 1.2;
        text-align: center;
        text-decoration: none;
        cursor: pointer;
        transition: background .18s ease, color .18s ease, border-color .18s ease;
      }
      .by-pdp-secondary-actions .by-wishlist-pdp:hover,
      .by-pdp-secondary-actions .by-wishlist-pdp.is-active,
      .by-pdp-quote:hover {
        background: #171717;
        border-color: #171717;
        color: #fff;
      }
      .by-pdp-quote svg {
        width: 21px;
        height: 21px;
        flex: 0 0 21px;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.7;
        stroke-linecap: round;
        stroke-linejoin: round;
      }
      .by-pdp-quote:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 3px;
      }
      @media (max-width: 430px) {
        .by-pdp-secondary-actions { grid-template-columns: 1fr; }
      }
      @media (prefers-reduced-motion: reduce) {
        .by-pdp-quote { transition: none; }
      }
    `;
    document.head.appendChild(style);
  }

  function productData() {
    const node = document.getElementById('by-wishlist-product-data');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  }

  function buildQuoteHref(item) {
    const title = String(item?.title || document.querySelector('.product__title')?.textContent || 'Produkt').replace(/\s+/g, ' ').trim();
    let productUrl;
    try { productUrl = new URL(item?.url || location.href, location.origin); }
    catch (_) { productUrl = new URL(location.href); }
    productUrl.search = '';
    const variantInput = document.querySelector('.product__block--buttons form[action*="/cart/add"] [name="id"], product-form form [name="id"]');
    if (variantInput?.value) productUrl.searchParams.set('variant', variantInput.value);
    const subject = `${BY_QUOTE_TEXT.button} – ${title}`;
    const body = [
      BY_QUOTE_TEXT.hello,
      '',
      BY_QUOTE_TEXT.intro,
      '',
      title,
      productUrl.toString(),
      '',
      BY_QUOTE_TEXT.thanks
    ].join('\n');
    return `mailto:info@baristayou.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  function enhanceActions() {
    ensureStyles();
    const wishlist = document.querySelector('.product__block--buttons [data-by-wishlist-pdp]');
    if (!wishlist || document.querySelector('[data-by-pdp-secondary-actions]')) return;
    const item = productData();
    if (!item) return;
    const host = wishlist.parentElement;
    if (!host) return;

    const row = document.createElement('div');
    row.className = 'by-pdp-secondary-actions';
    row.dataset.byPdpSecondaryActions = '';

    const quote = document.createElement('a');
    quote.className = 'by-pdp-quote';
    quote.dataset.byPdpQuote = '';
    quote.href = buildQuoteHref(item);
    quote.setAttribute('aria-label', `${BY_QUOTE_TEXT.label} ${item.title || BY_QUOTE_TEXT.product} ${BY_QUOTE_TEXT.tail}`.trim());
    quote.innerHTML = QUOTE_ICON + '<span>'+BY_QUOTE_TEXT.button+'</span>';
    quote.addEventListener('click', () => { quote.href = buildQuoteHref(item); });

    host.insertBefore(row, wishlist);
    row.append(wishlist, quote);
  }

  function init() {
    ensureStyles();
    enhanceActions();
    let actionTimer; const observer = new MutationObserver(() => { clearTimeout(actionTimer); actionTimer=setTimeout(enhanceActions,80); });
    observer.observe(document.body, {childList:true, subtree:true});
    document.addEventListener('shopify:section:load', enhanceActions);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
